var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"https://dyverse.com/","target":"_blank"}},[_c('p',[_vm._v(" "+_vm._s(_vm.footerText)+" "),_c('PoweredbyIcon')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }